import { createSlice,createAsyncThunk} from "@reduxjs/toolkit";
import ProviderManager from "../../../provider/providerManager";
import { PROGRAM_STEPS } from "./OrganizationFamilyMembersSale/enums";
import { showAppLoader, hideAppLoader } from "../../Shared/Loader/LoaderSlice";


export const GeneralPurposeMagicLink = createAsyncThunk(
  "familyMembersSaleSlice/GeneralPurposeMagicLink",
  async (data) => {
    try {
      const res=await ProviderManager.getProviderData(
        "generalPurposeMagicLink",
        [
          data.clientName,
          data.scopeName,
          data.isDynamic,
          data.sendSms,
          data.sendEmail,
          data.parameters
        ],
        );
        return res;
    }
    catch (error) {};
    }
);
export const GetOrganizationDataFromEpi = createAsyncThunk(
  "familyMembersSaleSlice/GetOrganizationDataFromEpi",
  async (subscriberOrgId,thunkAPI) => {
    try {
      const result=await ProviderManager.getProviderData("getOrganizationData",[subscriberOrgId]);
      return result.Body?.data;
    }
    catch (error) {
      thunkAPI.dispatch(hideAppLoader());
    }
  }
);

const initialState = {
  selected:"",
  selectedType:"",
  programCurrentStep:PROGRAM_STEPS.MAIN,
  optionsData:{},
  cellularPlanForSale:null,
  loadingPackagesAfterML:true,
  organizationCellularPackages:null,
  selectedPackage:null,
  optionInputError:"אנא הזן מספר טלפון לניוד",
};

const familyMemberCellularSaleSlice = createSlice({
  name: 'familyMemberCellularSale',
  initialState: initialState,
  reducers: {
    setSelected: (state, action) => {
      state.selected = action.payload;
      return state;
    },
    setSelectedType: (state, action) => {
      state.selectedType = action.payload;
      return state;
    },
    setOptionsData:(state,action)=>{
      state.optionsData=action.payload;
      return state;
    },
    setProgramCurrentStep:(state,action)=>{
      state.programCurrentStep=action.payload;
      return state;
    },
    setCellularPlanForSale:(state,action)=>{
      state.cellularPlanForSale=action.payload;
      return state;
    },
    saveToHistory:(state,action)=>{
      return state;
    },
    setSelectedPackage: (state, action) => {
      state.selectedPackage = action.payload;
      return state;
    },
    setOptionInputError:(state,action)=>{
      state.optionInputError=action.payload;
      return state;
    },
    setLoadingPackagesAfterML:(state,action)=>{
      state.loadingPackagesAfterML=action.payload;
      return state;
    },
    cleanSliceData:(state)=>{
      state=initialState;
      return state;
    }
  },
  extraReducers: {
    [GetOrganizationDataFromEpi.fulfilled]: (state, action) => {
      state.loadingPackagesAfterML=false;
      state.organizationCellularPackages=action.payload?.cellularPackageList;
      return state;
    },
    [GetOrganizationDataFromEpi.rejected]: (state) => {
      state.loadingPackagesAfterML=false;
      state.organizationCellularPackages=null;
      return state;
    },
  },
})

export const {setSelected,
              setSelectedType,
              setOptionsData,
              setProgramCurrentStep,
              setCellularPlanForSale,
              saveToHistory,
              setSelectedPackage,
              setOptionInputError,
              setLoadingPackagesAfterML,
              cleanSliceData}=familyMemberCellularSaleSlice.actions;
export default familyMemberCellularSaleSlice.reducer;
